import '../css/ParkHeightsPage.css';
import logo from '../../assets/images/ParkHeightsLogo.webp';

import { Button, Carousel, Col, Container, Image, Row } from "react-bootstrap";


import heroImgTwo from '../../assets/images/CPR_PARK_HEIGHTS/heroImgTwo.webp';
import floorPlanImg from '../../assets/images/CPR_PARK_HEIGHTS/park-heights_floor_plan_layout.webp';
import allBlocksImg from '../../assets/images/CPR_PARK_HEIGHTS/allBlocks.webp';
import desinger_landscape from '../../assets/images/CPR_PARK_HEIGHTS/designer_landscape.webp';
import landscapeGreenery from '../../assets/images/CPR_PARK_HEIGHTS/landscapeGreenery.webp';
import clubhouseImg from '../../assets/images/CPR_PARK_HEIGHTS/clubhouse_horizontal.webp';

import banner_spec from '../../assets/images/img_one.webp'

import { faArrowRight, faBuilding, faBolt, faLayerGroup, faExpand, faCompass, faShield, faLeaf, faBasketballBall, faChild, faWalking, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FloatButton, Masonry, Modal } from 'antd';


// Amenities images for wellness section
import banquetHall from '../../assets/images/CPR_PARK_HEIGHTS/amenities/banquet-hall.webp';
import basketballCourt from '../../assets/images/CPR_PARK_HEIGHTS/amenities/basketballCourt.webp';
import tableGames from '../../assets/images/CPR_PARK_HEIGHTS/amenities/board&table-games.webp';
import gym from '../../assets/images/CPR_PARK_HEIGHTS/amenities/gym.webp';
import joggingTrack from '../../assets/images/CPR_PARK_HEIGHTS/amenities/jogging-track.webp';
import kidsPlayArea from '../../assets/images/CPR_PARK_HEIGHTS/amenities/kidsPlayArea.webp';
import libraryRoom from '../../assets/images/CPR_PARK_HEIGHTS/amenities/libraryRoom.webp';
import mainElevationEntrance from '../../assets/images/CPR_PARK_HEIGHTS/amenities/mainElevationEntrance.webp';
import securitySystem from '../../assets/images/CPR_PARK_HEIGHTS/amenities/securitySystem.webp';
import swimmingPool from '../../assets/images/CPR_PARK_HEIGHTS/amenities/swimmingPool.webp';
import yogaSpace from '../../assets/images/CPR_PARK_HEIGHTS/amenities/yoga-space.webp';


import { PhoneOutlined, WhatsAppOutlined } from '@ant-design/icons';


import CPR_Park_Heights_Brochure from '../../assets/docs/CPR_Park_Heights_Brochure.pdf';
import { Link, useNavigate } from 'react-router-dom';
import MetaHelper from '../MetaHelper';




const ParkHeightsPage = () => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formMode, setFormMode] = useState('manual'); 
    const [autoPopupCount, setAutoPopupCount] = useState(0);
    




    const [masonryColumns, setMasonryColumns] = useState(window.innerWidth < 768 ? 2 : 4);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        interest: '2 BHK Independent Flat', // Default value
        message: ''
    });
    const [formStatus, setFormStatus] = useState({ type: '', message: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'phone') {
            const onlyNums = value.replace(/[^0-9]/g, ''); // Remove anything not a number
            if (onlyNums.length <= 10) {
                setFormData(prev => ({ ...prev, [name]: onlyNums }));

                // Clear the error message if they are typing a valid-ish sequence
                if (formStatus.message === 'Please enter a valid 10-digit phone number.') {
                    setFormStatus({ type: '', message: '' });
                }
            }
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    // This is for contact section's for at the bottom of the page
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        // VALIDATION
        if(formData.phone.length !== 10) {
            setFormStatus({type: 'error', message: 'Please enter a valid 10-digit phone number.'});
            return;
        }
        setFormStatus({ type: 'loading', message: 'Sending inquiry...' });

        try {
            const response = await fetch('park-heights-contact.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({...formData, source: "Park Heights - From Contact Form"}),
            });
            
            const result = await response.json();

            if (result.status === 'success') {
                setFormStatus({ type: 'success', message: result.message });
                setFormData({ name: '', email: '', phone: '', interest: '2 BHK Independent Flat', message: '' });

                navigate('/cpr-park-heights/thank-you', {
                    state: {
                        project: 'CPR Park Heights',
                        returnPath: '/cpr-park-heights'
                    }
                });
            } else {
                setFormStatus({ type: 'error', message: result.message });
            }
        } catch (error) {
            setFormStatus({ type: 'error', message: 'Network error. Please try again later.' });
        }
    };

    const handleBrochureSubmit = async (e) => {
        e.preventDefault();

        if (formData.phone.length !== 10) {
            setFormStatus({ type: 'error', message: 'Please enter a valid 10-digit phone number.' });
            return;
        }

        // 1. OPEN YOUTUBE IMMEDIATELY (Replace with your specific link)
        window.open('https://www.youtube.com/watch?v=YOUR_PARK_HEIGHTS_VIDEO', '_blank');

        setFormStatus({ type: 'loading', message: 'Processing your request...' });

        const finalizeRequest = () => {
            setIsModalOpen(false);
            setFormData({ name: '', email: '', phone: '', interest: '2 BHK Independent Flat', message: '' });

            // 2. TRIGGER DOWNLOAD FOR EVERYONE
            const link = document.createElement('a');
            link.href = CPR_Park_Heights_Brochure; 
            link.download = 'CPR_Park_Heights_Brochure.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // 3. NAVIGATE TO PARK HEIGHTS THANK YOU PAGE
            navigate('/cpr-park-heights/thank-you', {
                state: {
                    project: 'CPR Park Heights',
                    returnPath: '/cpr-park-heights'
                }
            });
        };

        try {
            const response = await fetch('park-heights-contact.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    ...formData, 
                    interest: formMode === 'auto' ? 'Auto-Popup Enquiry' : 'Brochure Download Request',
                    source: `Park Heights - ${formMode === 'auto' ? 'Auto Popup' : 'Hero Button'}` 
                }),
            });

            const result = await response.json();
            if (result.status === 'success') {
                finalizeRequest();
            } else {
                setFormStatus({ type: 'error', message: result.message });
            }
        } catch (error) {
            console.error("Local/Network Error:", error);
            finalizeRequest();
        }
    };

    const handleBrochureClick = (e) => {
        if (e) e.preventDefault();
        setFormMode('manual'); // Force manual text
        setFormData(prev => ({ ...prev, interest: 'Brochure Download Request' }));
        setIsModalOpen(true);
    };

    useEffect(() => {
        const handleResize = () => {
            setMasonryColumns(window.innerWidth < 768 ? 2 : 4);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);



    useEffect(() => {
        let timer;
        // Trigger if modal is closed and hasn't appeared more than 3 times
        if (!isModalOpen && autoPopupCount < 3) {
            // First wait: 8 seconds | Subsequent waits: 40 seconds
            const delay = autoPopupCount === 0 ? 8000 : 40000;

            timer = setTimeout(() => {
                setFormMode('auto'); 
                setIsModalOpen(true);
                setAutoPopupCount(prev => prev + 1);
            }, delay);
        }
        return () => clearTimeout(timer);
    }, [isModalOpen, autoPopupCount]);

    const facts = [
        { icon: faExpand, title: "3 Acres", desc: "Expansive Gated Community Land" },
        { icon: faBuilding, title: "224 Units", desc: "Premium 2 & 3 BHK Apartments" },
        { icon: faLayerGroup, title: "Blocks A, B, C, D", desc: "Cellar + Stilt + 8 Floors Structure" },
        { icon: faCompass, title: "Vastu Compliant", desc: "Total Independent Homes Design" },
        { icon: faShield, title: "No Common Walls", desc: "3-Side Open for Maximum Ventilation" },
        { icon: faBolt, title: "100% Power Backup", desc: "Reliable Support for Common Areas & Fans" }
    ];
    
    const [envState, setEnvState] = useState('default'); // 'default', 'east', 'west'


    // ----------------------------------
    // Wellness and clubhouse part
    // ----------------------------------
    const wellnessMasonryImages = [
        {
            title: 'Grand Entrance', 
            img: mainElevationEntrance, // From Page 3 or 5
        },
        {
            title: 'Luxury Swimming Pool',
            img: swimmingPool, // From Page 6
        },
        {
            title: 'Multipurpose Hall', 
            img: banquetHall, // From Page 5
        },
        {
            title: 'Indoor Games Room',
            img: tableGames, // From Page 5
        },
        {
            title: 'Fully Equipped Gym',
            img: gym, // From Page 5
        },
        {
            title: 'Jogging Track',
            img: joggingTrack, // From Page 9
        },
        {
            title: 'Library & Reading Room',
            img: libraryRoom, // From Page 5
        },
        {
            title: 'Yoga & Meditation Hall',
            img: yogaSpace, // From Page 5
        },
        {
            title: 'Half Basketball Court',
            img: basketballCourt, // From Page 9
        },
        {
            title: 'Children’s Play Area',
            img: kidsPlayArea, // From Page 9
        },
        {
            title: '24/7 Gated Security',
            img: securitySystem, // From Page 8/9
        },
    ]

    // ----------------------------------
    // Care Pillars Section - Updated for CPR Park Heights
    // ----------------------------------
    const carePillars = [
        {
            title: "Divine Recreation",
            icon: faLayerGroup, 
            items: ["5-Level Luxury Clubhouse", "Yoga & Meditation Hall", "Library & Reading Room"],
            tag: "Spirit"
        },
        {
            title: "Active Lifestyle",
            icon: faBuilding, 
            items: ["Fully Equipped Gym", "Half Basketball Court", "Jogging & Walking Track"],
            tag: "Health"
        },
        {
            title: "Family Sanctuary",
            icon: faLeaf, 
            items: ["Children’s Play Area", "Designer Landscapes", "24/7 Gated Security"],
            tag: "Leisure"
        }
    ];

    // ----------------------------------
    // Location Section - Updated for Tirupati
    // ----------------------------------
    const locations = [
        { name: "Tirupati Airport", time: "15", desc: "International Hub", pos: "north" },
        { name: "Tirupati Rly Station", time: "08", desc: "Central Connectivity", pos: "east" },
        { name: "RTC Bus Stand", time: "07", desc: "Transit Hub", pos: "south" },
        { name: "Alipiri (Footsteps)", time: "15", desc: "Divine Access", pos: "west" }
    ];


    return(
        <Container fluid className="parkHeightsPage p-0">
            <MetaHelper 
                title="CPR Park Heights | Premium High-Rise Apartments Tirupati" 
                description="Luxury 2 & 3 BHK flats at CPR Park Heights, 200ft Bypass Road, Tirupati. Experience elevated living near Avilala Smart City Park."
            />
            <Row id='hero' className='hero-video-section mb-2 g-0'>
                {/* Using an image since no video is available; object-fit: cover maintains the hero look */}
                <img 
                    src={heroImgTwo} // Replace with your path to the brochure's main building render
                    alt="CPR Park Heights Exterior"
                    className="video hero-img" // Kept class name 'video' to inherit existing styles
                    style={{width: '100%', height: '100vh', objectFit: 'cover'}}
                    loading='lazy'
                />
                <div className='hero-overlay'>
                    <div className='hero-overlay-content text-center text-lg-end'>
                        <div className='left-side'>
                            <img src={banner_spec} className='banner-spec-img' />
                        </div>
                        <div className='right-side'>
                            <h3>Capital Protected Returns</h3>
                            <h1>CPR Park Heights</h1>
                            <h6>
                                Premium 2 & 3 BHK | 224 Units | 12000 Sq.ft. Clubhouse | Star Hotel Neighbourhood
                            </h6>
                            
                            {/* --- BUTTON PLACED DIRECTLY UNDER TEXT --- */}
                            <div className="hero-btn-wrapper mt-4 d-flex justify-content-center justify-content-lg-end">
                                <Button 
                                    variant="light" 
                                    className="download-brochure-btn px-4 py-2 rounded-pill fw-bold shadow-sm"
                                    // href={CPR_Park_Heights_Brochure} 
                                    // download="CPR_Park_Heights_Brochure.pdf"
                                    onClick={handleBrochureClick}
                                >
                                    DOWNLOAD BROCHURE 
                                    <FontAwesomeIcon icon={faArrowRight} className="ms-2 arrow-icon" />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Row>

            <Row id='overview' className="narrative-row g-0 align-items-center bg-white">
                {/* Left Side: Content Column */}
                <Col lg={6} className="narrative-content-col p-5 p-lg-10">
                    <div className="content-wrapper px-md-5">
                        <h6 className="section-subtitle mb-3">CITY OF DIVINITY</h6>
                        <h2 className="section-title mb-4">Where Your Home Grows in Value Every Day.</h2>
                        
                        <p className="narrative-paragraph">
                            Located in the revered temple town of Tirupati, <strong>CPR Park Heights</strong> rises in the heart of a rapidly emerging 
                            high‑growth corridor that is transforming into the city’s most sought‑after residential zone. 
                            Set near the lush <strong>Avilala Smart City Park</strong> and spread across 3 acres of premium land, this gated community offers 224 elegantly designed 
                            <strogn>2 & 3 BHK</strogn> homes across four well‑planned blocks (Cellar + Stilt + 8 Floors). 
                            The neighbourhood is surrounded by 
                            Tirupati’s finest hospitality landmarks, including Taj, Marriott, Lemon Tree, Ibis, and the upcoming Novotel, 
                            creating a vibrant urban ecosystem that signals strong future appreciation. 
                            With the Chennai–Bangalore Highway witnessing massive expansion in organised retail, branded outlets, 
                            and hospitality developments, the region is fast becoming a lifestyle and investment hotspot. 
                            The presence of key government offices and multiple 
                            upcoming civic and commercial projects further strengthens the area’s growth 
                            trajectory, positioning it for significant value appreciation over the next 24 months. 
                            Every residence at <strong>CPR Park Heights</strong> is crafted as 
                            a <strong>“Total Independent Home”</strong> with no shared walls, ensuring 360‑degree ventilation, abundant natural light, 
                            and complete privacy — all within a serene, oxygen‑rich environment designed for wellness, comfort, and happiness.
                        </p>

                        {/* <Button variant="outline-dark" className="mt-4 px-4 py-2 rounded-pill fw-bold">
                            EXPLORE THE VISION <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                        </Button> */}
                    </div>
                </Col>

                {/* Right Side: Image Carousel Column */}
                <Col lg={6} className="narrative-carousel-col">
                    <Carousel fade indicators={true} controls={false} interval={4000} className="h-100">
                        <Carousel.Item className="h-100">
                            <div className="narrative-img-frame">
                                <Image 
                                    src={heroImgTwo} 
                                    className="w-100 h-100 object-fit-cover" 
                                    alt="CPR Park Heights Architecture" 
                                    style={{objectPosition: 'center 20%'}}
                                />
                            </div>
                        </Carousel.Item>
                        <Carousel.Item className="h-100">
                            <div className="narrative-img-frame">
                                <Image 
                                    src={clubhouseImg} 
                                    className="w-100 h-100 object-fit-cover" 
                                    alt="Luxury Clubhouse and Pool" 
                                />
                            </div>
                        </Carousel.Item>
                    </Carousel>
                </Col>
            </Row>
            
            {/* Quick Facts Row */}
            <Row className="quick-facts-row g-0 py-5 bg-light justify-content-center">
                <Col md={10} className="py-5">
                    <div className="text-center mb-5">
                        <h6 className="section-subtitle">PROJECT AT A GLANCE</h6>
                        <h2 className="fw-bold">Defining Modern Living in Tirupati</h2>
                    </div>
                    <Row className="g-4">
                        {facts.map((fact, index) => (
                            <Col md={4} key={index} className="d-flex align-items-start p-4 fact-card">
                                <div className="fact-icon-box me-3">
                                    <FontAwesomeIcon icon={fact.icon} />
                                </div>
                                <div>
                                    <h5 className="fw-bold mb-1" style={{fontSize: '1.1rem'}}>{fact.title}</h5>
                                    <p className="text-muted mb-0 small">{fact.desc}</p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>

            {/* SECTION 4: THE ARCHITECTURE OF PRIVACY (INDEPENDENT HOMES LOGIC) */}
            <Row id='architecture' className="env-compass-section g-0 py-5 bg-white overflow-hidden">
                <Col lg={12} className="text-center mb-5">
                    <h6 className="section-subtitle">ARCHITECTURAL EXCELLENCE</h6>
                    <h2 className="section-title">The Privacy & Ventilation Compass</h2>
                    <p className="text-muted">Hover over the directions to see how our "No Common Wall" design captures nature.</p>
                </Col>

                <Container>
                    <Row className="align-items-center">
                        {/* Interactive UI Controls */}
                        <Col lg={3} className="order-2 order-lg-1">
                            <div 
                                className={`env-card ${envState === 'east' ? 'active' : ''}`}
                                onMouseEnter={() => setEnvState('east')}
                                onMouseLeave={() => setEnvState('default')}
                            >
                                <h5>East Facing</h5>
                                <p>Designed for Vastu-compliant mornings. These units welcome the first light, creating a bright and spiritually aligned living space.</p>
                                <span className="stat-tag">Vastu Optimized</span>
                            </div>

                            <div 
                                className={`env-card mt-4 ${envState === 'west' ? 'active' : ''}`}
                                onMouseEnter={() => setEnvState('west')}
                                onMouseLeave={() => setEnvState('default')}
                            >
                                <h5>West Facing</h5>
                                <p>Capture the "Oxygen-Rich" breeze from Avilala Park. These units are positioned for sunset views and maximum evening airflow.</p>
                                <span className="stat-tag">Park Views</span>
                            </div>
                        </Col>

                        {/* The Visual Floor Plan Area */}
                        <Col lg={6} className="order-1 order-lg-2 position-relative d-flex justify-content-center">
                            <div className="floor-plan-wrapper">
                                {/* Replace floorPlanImg with the Typical Floor Plan from Brochure Page 11 */}
                                <Image loading='lazy' src={floorPlanImg} alt="CPR Park Heights Typical Floor Plan" className="main-floor-plan" />

                                <AnimatePresence>
                                    {envState === 'east' && (
                                        <motion.div 
                                            initial={{ opacity: 0, x: -50 }}
                                            animate={{ opacity: 1, x: 0 }}
                                            exit={{ opacity: 0 }}
                                            className="sunlight-glow east"
                                        />
                                    )}
                                    {envState === 'west' && (
                                        <motion.div 
                                            initial={{ opacity: 0, x: 50 }}
                                            animate={{ opacity: 1, x: 0 }}
                                            exit={{ opacity: 0 }}
                                            className="sunlight-glow west"
                                        />
                                    )}
                                </AnimatePresence>

                                {/* Wind Lines pulse to show 3-side ventilation */}
                                <div className={`wind-container ${envState !== 'default' ? 'active' : ''}`}>
                                    <div className="wind-line line-1"></div>
                                    <div className="wind-line line-2"></div>
                                    <div className="wind-line line-3"></div>
                                </div>
                            </div>
                        </Col>

                        {/* Technical Details - Adapted for CPR Constructions' Quality Standards */}
                        <Col lg={3} className="order-3 p-4">
                            <div className="tech-spec-box">
                                <h4 className="fw-bold text-primary-blue">ZERO</h4>
                                <p className="small text-uppercase fw-bold mb-1">Common Walls</p>
                                <p className="text-muted extra-small">Every apartment is designed as an independent unit, ensuring total acoustic privacy and zero shared heat from neighbors.</p>
                            </div>
                            <div className="tech-spec-box mt-4">
                                <h4 className="fw-bold text-primary-blue">3-Side</h4>
                                <p className="small text-uppercase fw-bold mb-1">Open Airflow</p>
                                <p className="text-muted extra-small">Strategic block separation creates natural wind corridors, ensuring your home stays cool with fresh air from Avilala Park.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Row>
            
            {/* --- SECTION 5: INTERIOR SANCTUARY PART A (BEDROOMS) --- */}
            {/* --- SECTION 5: THE PRIVACY FACTOR --- */}
            <Row className="interior-showcase-row align-items-center bg-white px-3 px-lg-10 py-5">
                <Col lg={6} className="order-2 order-lg-1 pe-lg-5 py-4">
                    <motion.div
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h6 className="section-subtitle mb-3">TOTAL INDEPENDENCE</h6>
                        <h2 className="section-title mb-4">No Common Walls. Total Privacy.</h2>
                        <p className="narrative-paragraph">
                            Experience the luxury of an independent house within a secure gated community. 
                            At CPR Park Heights, our blocks are designed with significant gaps, ensuring 
                            <strong> zero shared walls</strong> between units. This architectural choice 
                            guarantees complete acoustic privacy and allows for 3-side ventilation in every home.
                        </p>
                    </motion.div>
                </Col>

                <Col lg={6} className="order-1 order-lg-2 py-4">
                    <div className="interior-image-card shadow-lg">
                        {/* USE IMAGE: Typical Floor Plan (Page 11) or Master Plan (Page 10) */}
                        <Image loading='lazy' src={allBlocksImg} className="w-100 h-100 object-fit-cover" alt="Independent Home Layout" />
                    </div>
                </Col>
            </Row>

            {/* --- SECTION 6: THE LANDSCAPE (The Greenery Section) --- */}
            <Row id='greenery' className="interior-showcase-row align-items-center bg-light px-3 px-lg-10 py-5">
                <Col lg={6} className="py-4">
                    <div className="interior-image-card shadow-lg">
                        {/* USE IMAGE: The beautiful Landscape/Garden render from Page 8 */}
                        <Image loading='lazy' src={landscapeGreenery} className="w-100 h-100 object-fit-cover" alt="Designer Landscapes" />
                    </div>
                </Col>

                <Col lg={6} className="ps-lg-5 py-4">
                    <motion.div
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h6 className="section-subtitle mb-3">NATURAL HARMONY</h6>
                        <h2 className="section-title mb-4">Greenery in different shades across open spaces</h2>
                        <p className="narrative-paragraph">
                            Life at CPR Park Heights is painted in shades of emerald. Our designer 
                            landscapes and meticulously planned open areas offer a peaceful retreat 
                            from the urban bustle. Whether it's a morning walk along the tree-lined 
                            paths or quiet reflection in the garden, nature is your constant companion.
                        </p>
                    </motion.div>
                </Col>
            </Row>
            {/* <Row className="wellness-visual-grid g-0 py-5 bg-white">
                <Container>
                    <Col lg={12} className="text-center mb-5">
                        <motion.h6 
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            className="section-subtitle mb-3"
                        >
                            1,20,000 SQ.FT. ENVIRONMENTAL DECK
                        </motion.h6>

                        <motion.h2 
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2 }}
                            className="display-5 fw-bold text-primary-blue"
                        >
                            The Wellness Retreat & Clubhouse
                        </motion.h2>
                        
                        <motion.p 
                            initial={{ opacity: 0 }}
                            whileInView={{ opacity: 1 }}
                            transition={{ delay: 0.4 }}
                            className="text-muted mx-auto mt-3" 
                            style={{ maxWidth: '700px' }}
                        >
                            A destination within your community, thoughtfully designed to elevate lifestyle, 
                            leisure, and joy 400ft above the horizon.
                        </motion.p>
                    </Col>
                    <div className="bento-wrapper">
                        {wellnessBentoImages.map((item, index) => (
                            <motion.div 
                                key={index}
                                className="bento-box"
                                style={{ gridColumn: item.col, gridRow: item.row }}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: index * 0.1 }}
                                viewport={{ once: true }}
                            >
                                <div className="bento-inner">
                                    <img src={item.img} alt={item.title} className="bento-img" />
                                    <div className="bento-content-overlay">
                                        <h4>{item.title}</h4>
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </Container>
            </Row> */}
            <Row id='clubhouse' className='wellness-masonry-grid p-5 bg-white'>
                <Col lg={12} className="text-center mb-5">
                    <motion.h6 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        className="section-subtitle mb-3"
                    >
                        12,034 SQ.FT. LUXURY CLUBHOUSE
                    </motion.h6>

                    <motion.h2 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                        className="display-5 fw-bold text-primary-blue"
                    >
                        The Wellness Retreat & Recreation
                    </motion.h2>
                    
                    <motion.p 
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ delay: 0.4 }}
                        className="text-muted mx-auto mt-3" 
                        style={{ maxWidth: '700px' }}
                    >
                        A dedicated 5-level leisure destination designed to balance your indoor comforts 
                        with outdoor active living, featuring premium amenities in the heart of Tirupati.
                    </motion.p>
                </Col>
                <Masonry
                    columns={masonryColumns}
                    gutter={16}
                    items={wellnessMasonryImages.map((item, index) => ({
                        key: `item-${index}`,
                        data: item,
                    }))}
                    itemRender={({ data }) => (
                        <div className="wellness-masonry-item">
                            <img 
                                src={`${data.img}?w=523&auto=format`} 
                                alt={data.title} 
                                className="wellness-img" 
                                loading='lazy'
                            />
                            <div className="wellness-overlay">
                                <div className="wellness-overlay-content">
                                    <h4>{data.title}</h4>
                                </div>
                            </div>
                        </div>
                    )}
                />
                <div className='text-end mt-3'><strong>**All images are for illustrative purposes only</strong></div>
            </Row>

            {/* FEATURED AMENITY SPOTLIGHT: The 5-Level Clubhouse */}
            <Row className="wellness-spotlight-row g-0 bg-white p-5">
                <Container>
                    <Row className="align-items-center">
                        <Col lg={7} className="mb-4 mb-lg-0">
                            <div className="spotlight-image-container">
                                <Image 
                                    src={clubhouseImg} // Use the visual from Page 6 (Pool & Facade)
                                    className="img-fluid rounded-4 shadow-sm" 
                                    alt="CPR Park Heights Clubhouse" 
                                />
                            </div>
                        </Col>
                        <Col lg={5} className="ps-lg-5">
                            <motion.div
                                initial={{ opacity: 0, x: 20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                            >
                                <h6 className="section-subtitle mb-2">EXCLUSIVE ACCESS</h6>
                                <h2 className="fw-bold mb-4">5 Levels of Leisure</h2>
                                <p className="text-muted mb-4">
                                    Designed with passion and focused on holistic wellness, our 
                                    <strong> 12,034 Sq. Ft. Clubhouse</strong> is the heart of the community. 
                                    From the grand entrance lobby to the rooftop meditation zones, every 
                                    floor is crafted to provide a perfect balance of indoor and outdoor living.
                                </p>
                                <div className="d-flex gap-3">
                                    <div className="mini-stat">
                                        <h4 className="mb-0 fw-bold">12K</h4>
                                        <small className="text-muted">Square Feet</small>
                                    </div>
                                    <div className="mini-stat">
                                        <h4 className="mb-0 fw-bold">5</h4>
                                        <small className="text-muted">Leisure Levels</small>
                                    </div>
                                </div>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </Row>
            
            {/* SECTION 4.5: THE GREEN ACRES (The 3-Acre Community Landscape) */}
            <Row className="env-deck-showcase g-0 p-5 bg-light">
                <Container>
                    <Row className="align-items-center">
                        <Col lg={5} className="order-2 order-lg-1">
                            <motion.div
                                initial={{ opacity: 0, x: -30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                            >
                                <h6 className="section-subtitle mb-3">OUTDOOR SERENITY</h6>
                                <h2 className="section-title mb-4">Magical Landscape with 60ft Wide Open Spaces</h2>
                                <p className="narrative-paragraph">
                                    Experience lush green open spaces designed between the blocks for a 
                        lifetime of freedom and freshness. At CPR Park Heights, we've 
                        engineered the layout to ensure maximum breathing room, creating 
                        a sanctuary of greenery in different shades.
                                </p>
                                <ul className="deck-features-list list-unstyled mt-4">
                                    <li className="mb-2"><FontAwesomeIcon icon={faBasketballBall} className="text-primary me-2"/> Half Basket Ball & Multi-Purpose Court</li>
                                    <li className="mb-2"><FontAwesomeIcon icon={faChild} className="text-success me-2"/> Dedicated Children's Play Areas</li>
                                    <li><FontAwesomeIcon icon={faWalking} className="text-info me-2"/> Jogging & Walking Zones</li>
                                </ul>
                            </motion.div>
                        </Col>
                        
                        <Col lg={7} className="order-1 order-lg-2 mb-4 mb-lg-0">
                            <div className="deck-visual-wrapper">
                                <Image 
                                    src={desinger_landscape} // Use the Master Plan from Page 10 or Greenery from Page 8
                                    className="img-fluid rounded-4 shadow-lg" 
                                    alt="CPR Park Heights Landscape" 
                                />
                                <div className="deck-stat-overlay">
                                    <div className="stat-item">
                                        <span>Open Space</span>
                                        <strong>60+ FT</strong>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Row>

            {/* Care Pillars Section  */}
            <Row className="care-pillars-section g-4">
                <Container>
                    <Row className="justify-content-center text-center mb-5">
                        <Col lg={12}>
                            <motion.h6 
                                initial={{ opacity: 0 }}
                                whileInView={{ opacity: 1 }}
                                className="section-subtitle text-cyan mb-2"
                            >
                                A BLESSED LIFESTYLE
                            </motion.h6>
                            <motion.h2 
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                className="fw-bold text-white display-5"
                            >
                                Community, Wellness & Security
                            </motion.h2>
                            <motion.p className="text-white-50 mt-3 mx-auto" style={{ maxWidth: '600px' }}>
                                Thoughtfully curated spaces designed to elevate the body, mind, and soul within a secure gated environment.
                            </motion.p>
                        </Col>
                    </Row>

                    <Row className='gy-4'>
                        {carePillars.map((pillar, idx) => (
                            <Col lg={4} key={idx}>
                                <motion.div 
                                    className="pillar-card"
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.6, delay: idx * 0.2 }}
                                    viewport={{ once: true }}
                                >
                                    <div className="pillar-header">
                                        <div className="pillar-icon-box">
                                            <FontAwesomeIcon icon={pillar.icon} />
                                        </div>
                                        <span className="pillar-tag">{pillar.tag}</span>
                                    </div>
                                    
                                    <h4 className="pillar-title">{pillar.title}</h4>
                                    
                                    <ul className="pillar-list">
                                        {pillar.items.map((feature, fIdx) => (
                                            <li key={fIdx}>{feature}</li>
                                        ))}
                                    </ul>
                                </motion.div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </Row>

            {/* Connectivity Section  */}
            <Row id='location' className="connectivity-section p-5 bg-white overflow-hidden">
                <Container>
                    <Row className="align-items-center">
                        <Col lg={5}>
                            <motion.h6 className="section-subtitle">STRATEGIC LOCATION</motion.h6>
                            {/* Changed "The Avilala Corridor" to a more fitting title */}
                            <h2 className="display-5 fw-bold text-primary-blue">The Smart City Hub</h2>
                            
                            <p className="lead text-muted mt-4">
                                Ideally positioned on the <strong>200ft Bypass Road</strong>, CPR Park Heights 
                                offers a life of convenience in Tirupati’s most coveted residential 
                                neighborhood, perfectly balancing spiritual heritage with modern infrastructure.
                            </p>

                            <div className="investment-badge mt-4 p-4 border-start border-4 border-info bg-light rounded-end">
                                <h5 className="fw-bold mb-1">Developer Legacy</h5>
                                <p className="text-muted small mb-2">CPR Constructions - Shaping Lives</p>
                                <h3 className="fw-extrabold text-primary-blue mb-0">ISO 9001:2015</h3>
                                <small className="text-uppercase tracking-wider fw-bold">Quality Certified Excellence</small>
                            </div>
                        </Col>

                        <Col lg={7} className="radar-viewport">
                            <div className="radar-system">
                                {/* The Central Hub */}
                                <div className="credence-hub">
                                    <div className="radar-ping"></div>
                                    <div className="radar-ping secondary"></div>
                                    <div className="hub-logo-container">
                                        <Image loading='lazy' src={logo} alt="CPR Park Heights" style={{ width: '120px',}} />
                                    </div>
                                </div>

                                {/* The Orbital Nodes - Sourced from Page 17 */}
                                {locations.map((loc, index) => (
                                    <motion.div 
                                        key={index}
                                        className={`radar-node ${loc.pos}`}
                                        initial={{ opacity: 0, scale: 0 }}
                                        whileInView={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: index * 0.15, duration: 0.5 }}
                                    >
                                        <div className="node-capsule">
                                            <div className="node-time-hub">{loc.time}m</div>
                                            <div className="node-details">
                                                <h6>{loc.name}</h6>
                                                <p>{loc.desc}</p>
                                            </div>
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Row>

            {/* SECTION 11: CONTACT US */}
            <Row id="contact" className="contact-section g-0 py-5 bg-white">
                <Container className="py-5">
                    <Row className="gy-5 align-items-center">
                        {/* Left Side: Info */}
                        <Col lg={5}>
                            <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }}>
                                <h6 className="section-subtitle">GET IN TOUCH</h6>
                                <h2 className="section-title mb-4 text-primary-blue">Prices Rising Soon – Connect Now</h2>
                                <p className="narrative-paragraph mb-5">
                                    Experience the "Oxygen-Rich" life for yourself. Our sales gallery is open daily 
                                    to guide you through the 3-acre master plan and independent home layouts.
                                </p>

                                <div className="contact-detail-item d-flex mb-4">
                                    <div className="icon-box me-3">
                                        <FontAwesomeIcon icon={faPhoneAlt} /> 
                                    </div>
                                    <div>
                                        <h6 className="fw-bold mb-1">Call for Enquiries</h6>
                                        <div className="d-flex flex-column">
                                            <div className='contact-number'>
                                                <div>Abhinav. K</div>
                                                <a href="tel:+919908788633" className="text-decoration-none text-dark fw-bold mb-1">
                                                    +91 99087 88633
                                                </a>
                                            </div>
                                            <div className='contact-number'>
                                                <div>Bharathi.V:</div>
                                                <a href="tel:+917330851777" className="text-decoration-none text-dark fw-bold mb-1">
                                                    +91 73308 51777
                                                </a>
                                            </div>
                                            <div className='contact-number'>
                                                <div>Kasi.V:</div>
                                                <a href="tel:+919492040502" className="text-decoration-none text-dark fw-bold mb-1">
                                                    +91 94920 40502
                                                </a>
                                            </div>
                                        </div>
                                        <p className="text-muted small mt-1 mb-0">Sales & Site Visit Queries</p>
                                    </div>
                                </div>

                                <div className="contact-detail-item d-flex mb-4">
                                    <div className="icon-box me-3"><FontAwesomeIcon icon={faCompass} /></div>
                                    <div>
                                        <h6 className="fw-bold mb-1">Site Address</h6>
                                        <p className="text-muted small">200ft Road, beside Southern Spice Restaurant, near Avilala, Tirupati, Andhra Pradesh, 517508.</p>
                                    </div>
                                </div>

                                <div className="contact-detail-item d-flex mb-4">
                                    <div className="icon-box me-3"><FontAwesomeIcon icon={faBuilding} /></div>
                                    <div>
                                        <h6 className="fw-bold mb-1">Office</h6>
                                        <p className="text-muted small">CPR Constructions, Renigunta Rd, beside Ankura Hospital, Korramenugunta, Tirupati, Andhra Pradesh 517501.</p>
                                    </div>
                                </div>
                            </motion.div>
                        </Col>

                        {/* Right Side: Functional Form */}
                        <Col lg={{ span: 6, offset: 1 }}>
                            <motion.div className="contact-form-card p-4 p-md-5 shadow-lg rounded-4" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}>
                                <h4 className="fw-bold mb-4">Enquire Now</h4>
                                <form onSubmit={handleFormSubmit}>
                                    <Row className="g-3">
                                        <Col md={12}>
                                            <input name="name" type="text" className="form-control custom-input" placeholder="Full Name" value={formData.name} onChange={handleInputChange} required />
                                        </Col>
                                        <Col md={6}>
                                            <input name="email" type="email" className="form-control custom-input" placeholder="Email Address" value={formData.email} onChange={handleInputChange} required />
                                        </Col>
                                        <Col md={6}>
                                            <input 
                                                name="phone" 
                                                type="tel" 
                                                className="form-control custom-input" 
                                                placeholder="Phone Number" 
                                                value={formData.phone} 
                                                onChange={handleInputChange} 
                                                required
                                                pattern='[0-9]{10}'
                                                inputMode='numeric' 
                                            />
                                            {/* INLINE ERROR TEXT */}
                                            {formData.phone.length > 0 && formData.phone.length < 10 && (
                                                <small className="text-danger" style={{ fontSize: '10px', display: 'block', marginTop: '2px' }}>
                                                    Must be 10 digits
                                                </small>
                                            )}
                                        </Col>
                                        <Col md={12}>
                                            <select name="interest" className="form-select custom-input" value={formData.interest} onChange={handleInputChange}>
                                                <option value="2 BHK Independent Flat">2 BHK Independent Flat</option>
                                                <option value="3 BHK Independent Flat">3 BHK Independent Flat</option>
                                                <option value="Site Visit Request">Site Visit Request</option>
                                            </select>
                                        </Col>
                                        <Col md={12}>
                                            <textarea name="message" className="form-control custom-input" rows="4" placeholder="Your Message" value={formData.message} onChange={handleInputChange}></textarea>
                                        </Col>
                                        <Col md={12}>
                                            <Button type="submit" disabled={formStatus.type === 'loading'} className="w-100 py-3 mt-2 fw-bold bg-primary-blue border-0 rounded-3">
                                                {formStatus.type === 'loading' ? 'SENDING...' : 'SEND ENQUIRY'}
                                            </Button>
                                            {formStatus.message && (
                                                <div className={`mt-3 small text-center ${formStatus.type === 'error' ? 'text-danger' : 'text-success'}`}>
                                                    {formStatus.message}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </form>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </Row>

            {/* FOOTER SECTION */}
            <footer className="bg-dark text-white py-5">
                <Container>
                    <Row className="align-items-center gy-4">
                        <Col lg={4} className="text-center text-lg-start">
                            <Image loading='lazy' src={logo} alt="CPR Park Heights" style={{ width: '120px',}} />
                            <p className="mt-3 text-white-50 small">
                                A premium gated community project by CPR Constructions, 
                                redefining luxury living in the City of Divinity.
                            </p>
                        </Col>
                        <Col lg={4} className="text-center">
                            <h6 className="fw-bold mb-3">Quick Links</h6>
                            <div className="d-flex justify-content-center gap-3">
                                <a href="#overview" className="text-white-50 text-decoration-none small">Overview</a>
                                <a href="#architecture" className="text-white-50 text-decoration-none small">Architecture</a>
                                <a href="#clubhouse" className="text-white-50 text-decoration-none small">Clubhouse</a>
                                <a href="#location" className="text-white-50 text-decoration-none small">Location</a>
                                {/* Use Link for the Privacy Policy route */}
                                <Link to="/privacy-policy" className="text-white-50 text-decoration-none small">
                                    Privacy Policy
                                </Link>
                            </div>
                        </Col>
                        <Col lg={4} className="text-center text-lg-end">
                            <p className="mb-0 small text-white-50">© 2026 CPR Constructions. All Rights Reserved.</p>
                            <p className="small text-white-50">RERA: P10260132766</p>
                            {/* Your Brand Credit Added Here */}
                            <p className="mb-0 small" style={{ color: '#888' }}>
                                Designed by <a 
                                    href="https://bixianperformancemarketing.com"
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{ color: '#00d1ff', textDecoration: 'none', fontWeight: '500' }}
                                >
                                    Bixian Performance Marketing
                                </a>
                            </p>
                        </Col>
                    </Row>
                </Container>
            </footer>

            <Modal
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                centered
                destroyOnClose={true}
                className="brochure-modal"
            >
                <div className="p-3">
                    <div className="text-center mb-4">
                        <h3 className="fw-bold text-primary-blue">
                            {formMode === 'manual' ? "Get the Full Brochure" : "View Current Site Progress?"}
                        </h3>
                        <p className="text-muted">
                            {formMode === 'manual' 
                                ? "Enter your details to unlock the project specifications and floor plans." 
                                : "Leave your details below and our team will reach out to help you find your dream home."
                            }
                        </p>
                    </div>
                    
                    {/* Fixed onSubmit handler */}
                    <form onSubmit={handleBrochureSubmit}>
                        <div className="mb-3">
                            <input name="name" type="text" className="form-control custom-input" placeholder="Full Name" value={formData.name} onChange={handleInputChange} required />
                        </div>
                        <Row className="g-2 mb-3">
                            <Col md={6}>
                                <input name="email" type="email" className="form-control custom-input" placeholder="Email Address" value={formData.email} onChange={handleInputChange} required />
                            </Col>
                            <Col md={6}>
                                <input 
                                    name="phone" 
                                    type="tel" 
                                    className="form-control custom-input" 
                                    placeholder="Phone Number" 
                                    value={formData.phone} 
                                    onChange={handleInputChange} 
                                    required
                                    pattern='[0-9]{10}'
                                    inputMode='numeric' 
                                />
                                {/* INLINE ERROR TEXT */}
                                {formData.phone.length > 0 && formData.phone.length < 10 && (
                                    <small className="text-danger" style={{ fontSize: '10px', display: 'block', marginTop: '2px' }}>
                                        Must be 10 digits
                                    </small>
                                )}
                            </Col>
                        </Row>
                        <div className="mb-3">
                            <textarea name="message" className="form-control custom-input" rows="3" placeholder="Any specific requirements? (Optional)" value={formData.message} onChange={handleInputChange}></textarea>
                        </div>
                        <Button 
                            type="submit" 
                            disabled={formStatus.type === 'loading'} 
                            className="w-100 py-3 bg-primary-blue border-0 rounded-pill fw-bold shadow text-white"
                        >
                            {formStatus.type === 'loading' 
                                ? 'PROCESSING...' 
                                : (formMode === 'manual' ? 'SUBMIT & DOWNLOAD' : 'View Current Site Progress')
                            }
                        </Button>
                    </form>
                </div>
            </Modal>


            {/* FLOATING ACTION BUTTONS */}
            <FloatButton.Group
                trigger="hover"
                type="primary"
                style={{ insetInlineEnd: 24, bottom: 24 }}
                icon={<FontAwesomeIcon icon={faCompass} />} // Using your project's theme icon
            >

                {/* Call Button */}
                <FloatButton 
                    icon={<PhoneOutlined />} 
                    href="tel:+919491812277"
                    tooltip={<div>Call Sales Team</div>}
                />


                {/* WhatsApp Button - Using official brand color */}
                <FloatButton 
                    icon={<WhatsAppOutlined />} 
                    target="_blank"
                    href="https://wa.me/+919849643621" // Replace with actual WhatsApp number
                    tooltip={<div>WhatsApp Us</div>}
                    style={{ backgroundColor: '#25D366', color: '#fff' }} 
                />

                {/* Back to Top - Specialized button that handles scrolling automatically */}
                <FloatButton.BackTop 
                    tooltip={<div>Scroll to Top</div>} 
                />
            </FloatButton.Group>
        </Container>
    )
};

export default ParkHeightsPage;